module.exports = __webpack_public_path__ + "img/Fixit_timebestilling_logo_outline.837a867.svg";